import { render, staticRenderFns } from "./billsPaymentProviderForm.vue?vue&type=template&id=6ccfb169"
import script from "./billsPaymentProviderForm.vue?vue&type=script&lang=js"
export * from "./billsPaymentProviderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports